var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { E_USERS_ACTION_TYPES } from 'src/redux/users/actionTypes';
var initialState = {
    allColumns: [],
    collection: {
        results: [],
        isLoading: false,
        total: 0,
        filters: null,
    },
    import: {
        isLoading: false,
    },
    current: null,
};
export var usersReducer = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case E_USERS_ACTION_TYPES.FETCH_USERS_SUCCEEDED: {
            var _a = action.users, collectionResults = _a.collectionResults, total = _a.total;
            return __assign(__assign({}, state), { collection: __assign(__assign({}, state.collection), { results: collectionResults, total: total }) });
        }
        case E_USERS_ACTION_TYPES.UPDATE_USERS_COLLECTION_LOADING: {
            var isLoading = action.isLoading;
            return __assign(__assign({}, state), { collection: __assign(__assign({}, state.collection), { isLoading: isLoading }) });
        }
        case E_USERS_ACTION_TYPES.SAVE_USERS_ALL_COLUMNS: {
            var allColumns = action.allColumns;
            return __assign(__assign({}, state), { allColumns: allColumns });
        }
        case E_USERS_ACTION_TYPES.UPDATE_USERS_COLUMN: {
            var columns = action.columns;
            return __assign(__assign({}, state), { collection: __assign(__assign({}, state.collection), { columns: columns }) });
        }
        case E_USERS_ACTION_TYPES.UPDATE_USERS_FILTERS_SUCCEEDED: {
            var filters = action.filters;
            return __assign(__assign({}, state), { collection: __assign(__assign({}, state.collection), { filters: __assign(__assign({}, state.collection.filters), filters) }) });
        }
        case E_USERS_ACTION_TYPES.FETCH_CURRENT_USER_DETAILS_SUCCEEDED: {
            var user = action.user;
            return __assign(__assign({}, state), { current: user });
        }
        case E_USERS_ACTION_TYPES.CLEAR_CURRENT_USER: {
            return __assign(__assign({}, state), { current: initialState.current });
        }
        case E_USERS_ACTION_TYPES.UPDATE_USERS_IMPORT_LOADING: {
            var isLoading = action.isLoading;
            return __assign(__assign({}, state), { import: __assign(__assign({}, state.import), { isLoading: isLoading }) });
        }
        case E_USERS_ACTION_TYPES.IMPORT_USERS_IN_CSV_SUCCEEDED: {
            var result = action.result;
            return __assign(__assign({}, state), { import: __assign(__assign({}, state.import), { result: result }) });
        }
        case E_USERS_ACTION_TYPES.CLEAR_USERS_IMPORT: {
            return __assign(__assign({}, state), { import: initialState.import });
        }
        default:
            return state;
    }
};
